import React, { FC, memo, useMemo } from 'react'
import { Container } from '@ucheba/ui/components/Container/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import styled from 'styled-components'
import { AGREEMENTS_LINKS } from '@ucheba/utils/constants/core'
import EventHeroBrandingUcheba from '../../components/EventHeroBrandingUcheba/desktop'
import { IEventBrandingUchebaProps } from '../../types'
import EventsContent from '../../components/EventsContent/desktop'
import EventBrandingUchebaRegisration from '../../components/EventBrandingUchebaRegisration/desktop'
import ParentFormDialog from '../../../ParentFormDialog/desktop'
import { useEventsListItemCore } from '../../../EventsList/bll'
import ParentFormDialogSuccess from '../../../ParentFormDialog/desktop/ParentFormDialogSuccess'
import { socialText } from '../../constants'

const LinkAgreement = styled.a`
  color: #1d8afe;
  text-decoration: underline;
`

const EventPageBrandingUchebaNotFinished: FC<IEventBrandingUchebaProps> = (props) => {
  const { content, streamUrl, institution, rubric, templateId } = props

  const { onClickRegistration, messengersDialog, buttonData } = useEventsListItemCore({
    ...props,
  })

  const description = useMemo(() => {
    if (!institution) {
      if (buttonData.eventRegisteredStatus === 'watchBroadcast') {
        return socialText.started.description
      }

      return rubric && rubric.id === 5
        ? socialText.notStart.description
        : `${socialText.notStart.description}${socialText.notStart.additionToDescription}`
    }

    return socialText.forInstitutions.description
  }, [buttonData.eventRegisteredStatus, institution, rubric])

  return (
    <>
      <EventHeroBrandingUcheba {...props} />

      <Container>
        <Grid as='main' justifyContent='space-between' spacing='xlarge'>
          <GridCol uxs={14}>{content && <EventsContent content={content} />}</GridCol>

          <GridCol uxs={10}>
            <Spacing spacing='uxlarge' />

            {buttonData.eventRegisteredStatus === 'isNotRegistered' && (
              <div style={{ position: 'relative', height: '100%' }}>
                <div style={{ position: 'sticky', top: '24px' }}>
                  <EventBrandingUchebaRegisration
                    {...props}
                    onClickRegistration={onClickRegistration}
                  />

                  <Spacing spacing='small' />
                </div>
              </div>
            )}

            {buttonData.eventRegisteredStatus === 'isRegistered' && (
              <div style={{ padding: '0 16px' }}>
                <Button color='blue' block>
                  Вы зарегистрированы на мероприятие
                </Button>

                <Spacing spacing='large' />

                <Text fontSize='small1' textAlign='center' html={false}>
                  За день до мероприятия мы пришлем вам напоминание,
                  <br /> а за 15 минут до начала — ссылку на подключение.
                </Text>
              </div>
            )}

            {buttonData.eventRegisteredStatus === 'watchBroadcast' && (
              <Button color='blue' href={streamUrl} block>
                Подключиться к трансляции
              </Button>
            )}
          </GridCol>
        </Grid>

        <Spacing spacing='ularge' />
      </Container>

      <ParentFormDialog exam={props?.exam} id={props?.id} />

      <ParentFormDialogSuccess
        templateId={templateId}
        open={messengersDialog.isActive}
        onClose={messengersDialog.closeDialog}
        isInstitution={!!institution}
        description={description}
        isNeedVk={!(rubric && rubric?.id === 5)}
      />
    </>
  )
}

export default memo(EventPageBrandingUchebaNotFinished)
